export default __webpack_public_path__ + "static/cloudImage-f7fd0b1ad384ee8adf67ec81f8946445.webp";